import {Box, CircularProgress, DialogContent, DialogContentText} from "@material-ui/core";
import React, {useEffect, useState} from "react";
import useGetContent from "Hooks/api/useGetContent";
import extendedDayjs from "Helpers/dayjs";
import useIsMounted from "Hooks/useIsMounted";

const PromotionalTerms = ({modalId}) => {
    const {getPromotionalTerms} = useGetContent();
    const [content, setContent] = useState(null);
    const [contentLoaded, setContentLoaded] = useState(false);
    const [error, setError] = useState(false);
    const isMounted = useIsMounted();

    const loadPageData = async () => {
        setContentLoaded(false);

        const data = await getPromotionalTerms();

        if (isMounted()) {
            if (data) {
                setContent({head: data.head, sections: data.sections});
                setContentLoaded(true);
            } else {
                setError(true);
            }
        }
    };

    const retry = () => {
        setError(false);
        loadPageData();
    };

    useEffect(() => {
        loadPageData();
    }, []);


    let date = false;
    if (content && content?.head?.registered) {
        date = extendedDayjs(content.head.registered).format('MMMM Do YYYY');
    }

    return (
        <>
            {
                contentLoaded ?
                    <DialogContent style={{whiteSpace: "break-spaces"}}>
                        {content.sections.map(section => (
                            <React.Fragment key={`section-${section.section}`}>
                                <DialogContentText component="h6" variant="h6">{section.section_heading}</DialogContentText>
                                <DialogContentText variant="subtitle2" dangerouslySetInnerHTML={{__html: section.section_content}}/>
                            </React.Fragment>
                        ))}
                        {date &&
                            <DialogContentText variant="subtitle2">
                                <em>Promotional Terms last updated on <b>{date}</b>.</em>
                            </DialogContentText>
                        }
                    </DialogContent> :
                    <Box py={6} display="flex" alignItems="center" justifyContent="center">
                        <CircularProgress/>
                    </Box>
            }
        </>
    );
};

export default PromotionalTerms;
